import { VehicleOfficeSearchViewModel } from '@api/index';

export const getVehicleName = (
  vehicle: VehicleOfficeSearchViewModel | null
): string => {
  if (!vehicle) return '';

  const text = vehicle.text ?? '';

  return text.trim();
};
